import Singleton from '../../app/_ugly/Singleton';
import Force from './Force';
import Medium from './Medium';
import Move from './Move';
import Paint from './Paint';
import styles from './Tool.module.scss';

class Tool {
  busy = false;

  constructor(state) {
    this.state = state;

    this.wrapper = document.createElement('div');
    this.wrapper.classList.add(styles.wrapper);
    this.wrapper.setAttribute('id', 'tool-box');
    document.body.appendChild(this.wrapper);

    this.updatePosition = this.updatePosition.bind(this);

    this.medium = new Medium(this.state, this.wrapper);
    this.move = new Move(this.wrapper, this.updatePosition);

    this.paints = [];

    for (let i = 0; i < 3; i++) {
      this.paints.push(new Paint(this.wrapper, i, this.move));
    }

    this.force = new Force(this.state, this.wrapper);

    Singleton.set('force-indicator', this.force);
    Singleton.set('toolbox', this);

    this.setState();
  }

  destructor() {
    document.body.removeChild(this);
  }

  setState() {
    for (let i = 0; i < this.paints.length; i++) {
      this.paints[i].setState(this.state);
    }
  }

  updatePosition(position) {
    this.move.setPosition(position);
    this.medium.setPosition(position);
  }

  update(state) {
    if (state !== this.state) {
      for (let i = 0; i < this.paints.length; i++) {
        this.paints[i].update(state);
      }

      this.medium.update(state);
      this.force.update(state);
    }

    this.state = state;
  }

  goToBasicPosition() {
    this.move.inertiaSetTargetPosition(100, window.innerHeight - 200);
  }

  markAsBusy() {
    if (!this.busy) {
      this.updateOpacity(true);
    }

    this.busy = true;
  }

  markAsReady() {
    if (this.busy) {
      this.updateOpacity(false);
    }

    this.busy = false;
  }

  updateOpacity(busy) {
    const opacity = busy ? 0.2 : 1.0;

    this.medium.container.style.opacity = opacity;

    for (let i = 0; i < this.paints.length; i++) {
      this.paints[i].paint.style.opacity = opacity;
    }
  }
}

export default Tool;
